/**
 * formatDuplication - function to new data to duplicate one checkpoint
 * @param  {Object} checkpointData - The checkpoint data (no model)
 * @param  {Object} [newValues={}] - The data to override inside the new checkpoint (like name)
 * @return {Object} - The object with new data to create new checkpoint
 */
export const formatDuplication = (checkpointData, newValues = {}) => {
	const data = { ...checkpointData, ...newValues };

	const { created, id, modified, stats, rules_v2, ...cleanData } = data;

	// Apply transformations to cleanData
	cleanData.voucher_required = Boolean(cleanData.voucher_required);

	// Create new rules without unwanted properties
	cleanData.rules = (cleanData.rules || []).map(
		({
			id,
			modified,
			checkpoint,
			weez_checkpoint_id,
			weez_id,
			removed,
			...rule
		}) => rule
	);

	// Clean supporting documents
	if (cleanData.supporting_document_rules) {
		cleanData.supporting_document_rules = cleanData.supporting_document_rules.map(
			({ id, supporting_document_definition, ...rest }) => {
				const { id: defId, ...definition } =
					supporting_document_definition || {};
				return {
					...rest,
					supporting_document_definition: definition
				};
			}
		);
	}

	return cleanData;
};

export const UNLIMITED_NUMBER_OF_ACCESS = 999;
export const UNLIMITED_NUMBER_OF_STRICT_ACCESS = null;

export const isNumberOfAccessUnlimited = value =>
	value === UNLIMITED_NUMBER_OF_ACCESS || value === null;

export const isNumberOfStrictAccessUnlimited = value =>
	value === UNLIMITED_NUMBER_OF_STRICT_ACCESS;
